module.exports = __webpack_public_path__ + "img/studying_hubs.4e61fc7e.png";